/* Collection product-type filter.

   The grid paginates at 11 with infinite scroll and collections reach 149 products,
   so filtering only what is in the DOM would silently return a partial answer. On the
   first filter interaction we harvest every remaining page, then filter the full set.
   State lives in the URL (?type=Hoodies) so it is shareable and survives back/forward.

   2026-09-08 — coordination fix. Two defects, one root cause: this filter and
   assets/pagination.js both wrote into #product-grid and neither knew about the other.

     1. After filtering, the grid got short, which pulled the pagination sentinel into
        view. The paginator then fetched `?type=Hoodies&page=2`. Nothing server-side
        reads `type`, so it appended a page of the UNFILTERED collection on top of the
        filtered set. Measured: Hoodies went 5 -> 22 cards while still claiming 5.

     2. harvest() seeded from the live DOM. If infinite scroll had already appended
        pages 2..n, those cards were counted once from the DOM and then fetched again,
        so every product on those pages existed twice. Measured: Crews rendered
        4 cards for a true set of 2, duplicating Inner Empire Crew and Lioness Crew.

   Three defences, deliberately overlapping, because the paginator is a separate
   custom element whose in-flight fetches we cannot cancel:
     a. park the paginator while a filter is active, and re-arm it on View All;
     b. harvest from the captured page-1 baseline plus fetched pages, never live DOM;
     c. a MutationObserver on the grid that drops anything appended that does not
        belong to the active filter. (c) is what makes a late-landing fetch harmless. */
(function () {
  var row = document.querySelector('[data-pc-filters]');
  var grid = document.getElementById('product-grid');
  if (!row || !grid) return;

  var pager = document.querySelector('pagination-theme');
  var ALL = null;                       // full card list once harvested
  var origHTML = grid.innerHTML;        // page-1 baseline, captured before any append
  var activeType = '';

  function cards(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-pc-type-holder]'));
  }
  function keyOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0].split('/products/').pop() : '';
  }
  function typeOf(card) { return card.getAttribute('data-pc-type') || ''; }

  function setCount(n) {
    document.querySelectorAll('[data-pc-total]').forEach(function (el) {
      el.textContent = String(n);
    });
  }

  /* The header used to show collection.all_products_count, which counts products the
     grid can never render because a Locksmith gate skips them inside the loop. The
     Liquid now emits the count that actually passes that gate. */
  function renderableCount() {
    var r = parseInt(row.getAttribute('data-pc-renderable-count') || '0', 10);
    if (r) return r;
    return parseInt(row.getAttribute('data-pc-collection-count') || '0', 10);
  }

  function parkPager() {
    if (!pager) return;
    try { if (pager.observer) pager.observer.unobserve(pager); } catch (e) {}
    pager.setAttribute('loading', 'true');   // makes loadProducts() early-return
    pager.setAttribute('hidden', 'hidden');
  }
  function armPager() {
    if (!pager) return;
    pager.removeAttribute('hidden');
    pager.removeAttribute('loading');
    try {
      pager.i = 2;                            // restart paging from page 2
      if (pager.observer) pager.observer.observe(pager);
    } catch (e) {}
  }

  /* Anything appended while a filter is active that is not part of that filter gets
     removed immediately. Covers a paginator fetch that was already in flight. */
  var mo = new MutationObserver(function (muts) {
    if (!activeType) return;
    var seen = {};
    cards(grid).forEach(function (c) { seen[keyOf(c)] = (seen[keyOf(c)] || 0) + 1; });
    muts.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (!n || n.nodeType !== 1) return;
        var holder = n.matches && n.matches('[data-pc-type-holder]') ? n
                   : (n.querySelector ? n.querySelector('[data-pc-type-holder]') : null);
        var host = holder ? (n.matches && n.matches('[data-pc-type-holder]') ? n : n) : null;
        if (!holder || !host || !host.parentNode) return;
        if (typeOf(holder) !== activeType || seen[keyOf(holder)] > 1) host.parentNode.removeChild(host);
      });
    });
  });
  mo.observe(grid, { childList: true });

  function pagesNeeded() {
    var total = parseInt(row.getAttribute('data-pc-collection-count') || '0', 10);
    var per = parseInt(row.getAttribute('data-pc-per-page') || '0', 10);
    if (!total || !per) return 1;
    return Math.ceil(total / per);
  }

  function harvest() {
    if (ALL) return Promise.resolve(ALL);
    var n = pagesNeeded();
    // Baseline from the captured page-1 HTML, NOT the live DOM, so cards the paginator
    // may already have appended are never counted twice.
    var base = document.createElement('div');
    base.innerHTML = origHTML;
    var here = cards(base);
    if (n <= 1) { ALL = here; return Promise.resolve(ALL); }
    row.setAttribute('data-busy', '1');
    var path = window.location.pathname;
    var jobs = [];
    for (var i = 2; i <= n; i++) {
      jobs.push(fetch(path + '?page=' + i, { credentials: 'same-origin' }).then(function (r) { return r.text(); }));
    }
    return Promise.all(jobs).then(function (htmls) {
      var out = here.slice();
      htmls.forEach(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var g = doc.getElementById('product-grid');
        if (g) cards(g).forEach(function (c) { out.push(document.importNode(c, true)); });
      });
      // Belt and braces: de-duplicate by product handle regardless of how we got here.
      var seen = {}, dedup = [];
      out.forEach(function (c) {
        var k = keyOf(c);
        if (k && seen[k]) return;
        if (k) seen[k] = 1;
        dedup.push(c);
      });
      ALL = dedup;
      row.removeAttribute('data-busy');
      return ALL;
    }).catch(function () {
      row.removeAttribute('data-busy');
      ALL = here;   // degrade to the baseline rather than hang
      return ALL;
    });
  }

  function apply(type, push) {
    activeType = type || '';
    Array.prototype.forEach.call(row.querySelectorAll('.pc-filter'), function (b) {
      var on = (b.getAttribute('data-pc-filter') || '') === activeType;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (!activeType) {
      grid.innerHTML = origHTML;
      setCount(renderableCount());
      armPager();
      if (push) history.pushState({ t: '' }, '', window.location.pathname);
      return;
    }

    parkPager();
    harvest().then(function (all) {
      if (activeType !== type) return;            // a newer click won
      var seen = {}, keep = [];
      all.forEach(function (c) {
        if (typeOf(c) !== type) return;
        var k = keyOf(c);
        if (k && seen[k]) return;
        if (k) seen[k] = 1;
        keep.push(c);
      });
      grid.innerHTML = '';
      keep.forEach(function (c) { grid.appendChild(c.cloneNode(true)); });
      setCount(keep.length);
      if (push) {
        history.pushState({ t: type }, '', window.location.pathname + '?type=' + encodeURIComponent(type));
      }
    });
  }

  row.addEventListener('click', function (e) {
    var b = e.target.closest('.pc-filter');
    if (!b) return;
    e.preventDefault();
    apply(b.getAttribute('data-pc-filter') || '', true);
  });

  window.addEventListener('popstate', function () {
    apply(new URLSearchParams(window.location.search).get('type') || '', false);
  });

  setCount(renderableCount());   // correct the header before any interaction
  var initial = new URLSearchParams(window.location.search).get('type');
  if (initial) apply(initial, false);
})();
